/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable max-len */
// /* eslint-disable security/detect-non-literal-fs-filename */
// /* eslint-disable max-len */

import React,{useState,useEffect,useCallback,useContext} from 'react'
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ShimmerTable } from 'react-shimmer-effects';
import HeaderContext from '../../Components/Context/HeaderContext';
import Pagination from '../../Components/Pagination';
import { DistributorActions } from '../../redux/actions';
import { distributorService } from '../../service/distributor.service';
import AcceptReject from './AcceptReject';
import EmptyOrderPage from './EmptyOrderPage';
import Filters from './Filters';
import OrderListing from './OrderListing';
import OrderListingSkeleton from './OrderListingSkeleton';
import './style.css';
import { useLocation } from 'react-router-dom';

function MyOrders() {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup,
        setraiseTicket,
    } = useContext(HeaderContext);
    const searchParams = useLocation();
    const searchP = new URLSearchParams(searchParams.search)
    const [payload, setpayload] = useState({});
    const [loading, setloading] = useState(true);
    const [modalType, setmodalType] = useState('');
    const [tableType, settableType] = useState('order');
    const [filterOpen, setfilterOpen] = useState(false);
    const [filterUrl, setfilterUrl] = useState('')
    const [sort, setsort] = useState('created_at+desc');
    const [currentpage, setcurrentpage] = useState(1);
    const [totalPgae, settotalPgae] = useState('');
    const [searchValue, setsearchValue] = useState('');
    const [allData, setallData] = useState({});
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [selectedID, setselectedID] = useState('');
    const [statusloader, setstatusloader] = useState(false)
    const [Filter, setFilter] = useState({
        order_type:[],
        order_status:[],
        payment_type:[]
    })
    const handlePageClick =(data) => {
        setloading(true);
        const page = data.selected + 1;
        setcurrentpage(page)
    };
    const [List, setList] = useState({
        order:[],
        draft:[],
    })
    const handleErrorMessage = (message)=>{
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
        }, 1000);
    }
    const handleSuccessMessage = (message)=>{
        SetSuccessMessage(message);
        setTimeout(() => {
            SetSuccessMessage('');
            setcolorValue(false);
            setloading(false)
        },1000)
    }
    const handleStatusApprove = async()=>{
        const body={
            status:modalType==='accept'?'1':'8'
        }
        const res = await distributorService.AcceptOrRejectDraftOrder(body,selectedID);
        if(!res.error && res.data.success_status){
            handleSuccessMessage(res.data.message);
            setstatusloader(false)
        }else{
            handleErrorMessage(res.data.message)
            setstatusloader(false)
        }
        setmodalType('');
        handleFetch();
    }
    const handleFetch = useCallback(
        async(url) => {
            if(url){
                setList({
                    order:[],
                    draft:[],
                })
            }
            let params =url?url:filterUrl
            if (searchP.get('subscription')){
                params +=`&subscription=${searchP.get('subscription')}`
            }
            if (searchP.get('freezed_ador_cash')){
                params +=`&freezed_ador_cash=${searchP.get('freezed_ador_cash')}`
            }
            let page = currentpage
            if(url) page =1;
            const orders = await distributorService.OrderList(tableType,sort,params,searchValue,page);
            if(orders?.data?.success_status){
                setcurrentpage(orders.data.data.current_page);
                setallData({
                    pagination:Number(orders.data.data.number_of_pages)
                })
                settotalPgae(Number(orders.data.data.number_of_pages))
                setList((prevState)=>({
                    ...prevState,
                    [tableType]:orders.data.data.Items
                }))
                setloading(false);
                setfilterOpen(false);
                if(url){
                    handleSuccessMessage('Filter(s) Applied')
                }
            }else{
                handleErrorMessage(orders.message.response.data.message)
            }
        },
        [tableType,sort,searchValue,currentpage],
    )
    
    useEffect(() => {
        handleFetch()
    }, [handleFetch])

    const handleChange =(key,val)=>{
        
        setList((prev)=>({
            ...prev,
            type:val
        }))
    }
    const handleExport = useCallback((() => {
        distributorService.OrderList(tableType,sort,filterUrl,searchValue,currentpage,exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                handleSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    settitle('');
                    // setshowPopup(false);
                }, 1000);
            }
        });
    }), [exportSelected]);
    useEffect(() => {
        if(exportSelected!==''){
            handleExport()
        }
    }, [handleExport])
    
    return (
        <div className='md:px-[46px] px-4'>
            {loading && (
                <>
                    {<OrderListingSkeleton/>}</>
            )}
            <>
                {!loading &&<div className="flex md:justify-between justify-start md:items-center items-start md:flex-row flex-col lg:mx-12 ml-0">
                    <ul className="nav nav-pills flex flex-row list-none pl-0 mb-4 mt-5 md:ml-12 ml-3" id="pills-tab" role="tablist">
                        <li className="nav-item mr-[70px]" role="presentation">
                            <a href="javascript:void(0)" onClick={()=>{
                                setList({
                                    order:[],
                                    draft:[],
                                })
                                setcurrentpage(1)
                                setloading(true)
                                settableType('order')
                            }} className={`nav-link block ${tableType!=='draft'?'active':''}  myOrders relative text-xs21 font-semibold text-[#555259]`} id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">My Orders</a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a href="javascript:void(0)" 
                            
                                onClick={()=>{
                                    setList({
                                        order:[],
                                        draft:[],
                                    })
                                    setcurrentpage(1)
                                    setloading(true)
                                    setfilterUrl('')
                                    settableType('draft')
                                }} 
                                className={`nav-link block ${tableType==='draft'?'active':''}  myOrders relative text-xs21 font-semibold text-[#555259]`} id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Draft Orders</a>
                        </li>
                    </ul>
                    {tableType==='order' &&<div className="filter">
                        <div className="flex mb-3 mt-3 mx-2 md:justify-end justify-strat items-center w-full relative">
                            <button 
                                onClick={()=>setfilterOpen(true)}
                                type="button" 
                                className="flex items-center bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px]"style={{border:'2px solid #E9EDF4'}} data-bs-toggle="modal" data-bs-target="#filtermodal">
                                {filterUrl === '' ? '' :<span className='mr-1'><img src="/images/red-button.png"></img></span>}Filter
                            </button>
                            <button
                                onClick={()=>setexportClick(!exportClick)} type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] ml-2 rounded-lg">
                                Export
                            </button>
                            <ul
                                initial={false}
                                // style={{top:'36px',left:'87px' }}
                                animate={exportClick ? 'open' : 'closed'}
                                className={`dropdown-menu min-w-[90px] top-[36px] absolute  md:left-[87px]  sm:left-[70px] export-left
              ${exportClick ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2`}
                            >
                                <li
                                    className="px-5 pb-1.5 pt-1"
                                >
                                    <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)" onClick={() => {
                                        setexportSelected('export-csv')}}>CSV</a>
                                </li>
                                <li className="px-5 py-1.5">
                                    <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)" onClick={() => setexportSelected(`html-to-pdf`)}>PDF</a>
                                </li>
                                <li className="px-5 pt-1.5 pb-5">
                                    <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)" onClick={() => setexportSelected('export-excel')}>Excel</a>
                                </li>
                            </ul>
                            <div className="ml-3 relative cursor-pointer sm:mt-0 mt-1">
                                <input type="text" onChange={(e)=>{
                                    setcurrentpage(1);
                                    setsearchValue(e.target.value)
                                }} className="w-[180px] h-9 border-2 border-[#E9EDF4] rounded-lg text-sm font-normal text-[#090406] placeholder:font-normal placeholder:text-sm placeholder:text-[#090406] pl-4 pr-14 outline-0" placeholder="Search" />
                                <img src="images/search-box.svg" alt="icon" className="absolute top-1.5 right-1" />
                            </div>
                        </div>
                    </div>}
                </div>}
                {!loading &&List.order.length >0 ?
                    
                    <>{tableType==='order' &&(
                        <OrderListing type={tableType} handleChange={settableType} sort={sort} setsort={setsort} Items={List.order} setFilter={setFilter}/>
                    )}</>:<>    {!loading && tableType === 'order'
                    && <EmptyOrderPage search="yes" text="no orders" all={searchValue.length > 0 ? 'under searched term' : 'found'} />}</>
                }
            </>
            <>
                {!loading &&List.draft.length >0 ?
                    
                    <>{tableType==='draft' &&(
                        <OrderListing 
                            type={tableType}
                            handleChange={settableType} 
                            Items={List.draft} 
                            setmodalType={setmodalType}
                            setselectedID={setselectedID} />
                    )}</>:<>
                        {!loading && tableType === 'draft'
            && <EmptyOrderPage search="yes" text="no orders" all={searchValue.length > 0 ? 'under searched term' : 'found'} />}
                    
                    </>
                }
            </>
            { List.draft.length > 0 ?
                <Pagination 
                    handlePageClick={handlePageClick}
                    List={allData}
                    currentPage={currentpage}
                    loading={loading}
                    totalPage={totalPgae}/>:List.order.length > 0 &&
                    <Pagination 
                        handlePageClick={handlePageClick}
                        List={allData}
                        currentPage={currentpage}
                        loading={loading}
                        totalPage={totalPgae}/>}
            <>
                {tableType==='draft' && (
                    <ReactModal isOpen={modalType !==''}>
                        <AcceptReject 
                            acceptRejectPopup={modalType}
                            setacceptRejectPopup={setmodalType}
                            setstatusloader={setstatusloader}
                            handleStatusApprove={handleStatusApprove}
                            statusloader={statusloader}/>
                    </ReactModal>
                )}
                {tableType==='order' && (
                    <ReactModal isOpen={filterOpen}>
                        <Filters close={setfilterOpen} filterOpen={filterOpen} setcurrentpage={setcurrentpage} setFilter={setFilter} Filter={Filter} handleFetch={handleFetch} setfilterUrl={setfilterUrl}/>
                    </ReactModal>
                )}
            </>
        </div>
    )
}
const mapStateToProps = (state) => {
    const { Cart,ViewOffer,Products,offerData }=state;
    return { Cart,ViewOffer,Products,offerData }

};

const mapDispatchToProps = {
    GetDetails:DistributorActions.GetOfferDetails,
    ProductList:DistributorActions.ProductListing,
    GetOfferData:DistributorActions.GetOfferData,
    cartList:DistributorActions.GetCartItems

}
export default connect(mapStateToProps, mapDispatchToProps)(MyOrders)
